var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"evt-actions",style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr'})},[_c('vs-button',{staticClass:"evt-actions",attrs:{"color":"success","size":"small"},on:{"click":_vm.onMap}},[_vm._v("地図へ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }